import AnyInputMeta from './AnyInput/meta';
import CompSelectorInputMeta from './CompSelectorInput/meta';
import DataPathSelectorMeta from './DataPathSelector/meta';
import ExprInputMeta from './ExprInput/meta';
import MultiRatioInputMeta from './MultiRatioInput/meta';
import IfSwitchBranchListMeta from './IfSwitchBranchList/meta';
import MethodArgumentsInputMeta from './MethodArgumentsInput/meta';
import ComponentMethodNameInputMeta from './ComponentMethodNameInput/meta';
import ParallelFlowListMeta from "../../../lib/builtin/designerComponents/ParallelFlowList/meta";
import IconSelectorInputMeta from './IconSelectorInput/meta';
import ListKeyingRuleInputMeta from './ListKeyingRuleInput/meta';
import BranchElseEditorMeta from './BranchElseEditor/meta';

/** @type {UICore.ComponentMeta[]} */
export const builtinDesignerComponents = [AnyInputMeta, ExprInputMeta, CompSelectorInputMeta, DataPathSelectorMeta, MultiRatioInputMeta, IconSelectorInputMeta, IfSwitchBranchListMeta, MethodArgumentsInputMeta, ComponentMethodNameInputMeta, ParallelFlowListMeta, ListKeyingRuleInputMeta, BranchElseEditorMeta];
//# sourceMappingURL=index.js.map
